import React, { useMemo, useEffect, useState } from "react";
import objectPath from "object-path";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { Topbar } from "./Topbar";
import { HeaderMenuWrapper } from "./header-menu/HeaderMenuWrapper";
import { AnimateLoading } from "../../../_partials/controls";
import { useSelector } from "react-redux";

export function Header(props) {
  const uiService = useHtmlClassService();
  const jsonFile = useSelector((state) => state.style);

  const layoutProps = useMemo(() => {
    return {
      headerClasses: uiService.getClasses("header", true),
      headerAttributes: uiService.getAttributes("header"),
      headerContainerClasses: uiService.getClasses("header_container", true),
      menuHeaderDisplay: objectPath.get(
        uiService.config,
        "header.menu.self.display"
      ),
    };
  }, [uiService]);
  let ApiUrl = `${process.env.REACT_APP_API_END_POINT}`;
  let title = (
    <p
      style={
        jsonFile?.mainheaderTitleColor
          ? { color: jsonFile?.mainheaderTitleColor, marginTop: "15px" }
          : { marginTop: "15px" }
      }
    >
      <div
        dangerouslySetInnerHTML={{ __html: jsonFile?.mainHeaderTitle }}
      ></div>
    </p>
  );
  if (ApiUrl.includes("refactor")) {
    title = (
      <p
        style={
          jsonFile?.headerTitleColor
            ? { color: jsonFile?.headerTitleColor, marginTop: "15px" }
            : { color: "red", marginTop: "15px" }
        }
      >
        <div dangerouslySetInnerHTML={{ __html: jsonFile?.headerTitle }}></div>
      </p>
    );
  } else {
    title = (
      <p
        style={
          jsonFile?.mainheaderTitleColor
            ? { color: jsonFile.mainheaderTitleColor, marginTop: "15px" }
            : { marginTop: "15px" }
        }
      >
        <div
          dangerouslySetInnerHTML={{ __html: jsonFile?.mainHeaderTitle }}
        ></div>
      </p>
    );
  }

  return (
    <>
      {/*begin::Header*/}
      <div
        className={`header ${layoutProps.headerClasses}`}
        id="kt_header"
        {...layoutProps.headerAttributes}
      >
        {/*begin::Container*/}
        <div
          className={` ${layoutProps.headerContainerClasses} d-flex align-items-stretch justify-content-between`}
        >
          {/* {layoutProps.headerContainerClasses && ( */}
          <b
            className="d-flex colorTitle align-items-center textFont16 "
            style={{ direction: "rtl" }}
          >
            {title}{" "}
          </b>
          {/* )} */}

          <AnimateLoading />
          {/*begin::Header Menu Wrapper*/}
          {layoutProps.menuHeaderDisplay && <HeaderMenuWrapper />}
          <Topbar refreshQuickCartable={props.refreshQuickCartable} />
          {!layoutProps.menuHeaderDisplay && <div />}
          {/*end::Header Menu Wrapper*/}
          {/*begin::Topbar*/}
          {/*end::Topbar*/}
        </div>
        {/*end::Container*/}
      </div>
      {/*end::Header*/}
    </>
  );
}
